import React from "react";
import PropTypes from 'prop-types';
import './styles.scss';

export default class ContextMenu extends React.Component {

  static propTypes = {
    parentRef: PropTypes.oneOfType([
      PropTypes.func, 
      PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    items: PropTypes.array.isRequired,
    canShow: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      yPos: '0px',
      xPos: '0px',
      showMenu: false
    };

    this.menuRef = React.createRef();
    this.onContextMenu = this.onContextMenu.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    if (this.props.parentRef && this.props.parentRef.current)
      this.props.parentRef.current.addEventListener('contextmenu', this.onContextMenu);
  }

  componentWillUnmount() {
    if (this.props.parentRef && this.props.parentRef.current)
      this.props.parentRef.current.removeEventListener('contextmenu', this.onContextMenu);
  }

  onContextMenu(e) {
    // display default context menu when clicking inside an input element
    if (e.target.nodeName !== 'INPUT' || document.activeElement !== e.target) {
      e.preventDefault();
      if (this.props.canShow) {
        this.setState({ yPos: e.clientY, xPos: e.clientX, showMenu: true });
        document.addEventListener('mousedown', this.onClick);
      }
    }
  }

  onClick(e) {
    e.preventDefault();
    // do nothing on middle button click (similar to the browser behaviour)
    if (e.which === 2)
      return;
    // call onClick event only on left click
    if (e.which === 1 && e.target.parentElement && e.target.parentElement.id === "contextMenu")
      this.props.items[e.target.getAttribute('index')].onClick();

    document.removeEventListener('mousedown', this.onClick);
    this.setState({ showMenu: false });
  }

  render() {
    return (
      <div>
        {this.state.showMenu && (
          <div id="contextMenu" className="contextMenu" ref={this.menuRef} style={{ top: this.state.yPos, left: this.state.xPos }}>
            {this.props.items.map((item, i) => (
              <div key={item.id} index={i}>{item.label}</div>
            ))}
          </div>
        )}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ContextMenu/index.js